var map = {
	"./1-bottom.png": "a412",
	"./1-top.png": "d901",
	"./2-bottom.png": "ef55",
	"./2-top.png": "3ff7",
	"./2_проблемы фон_1.png": "549f",
	"./2_проблемы фон_2.png": "1a5d",
	"./3-bottom.png": "a77b",
	"./3-top.png": "73d3",
	"./4-bottom.png": "fbc2",
	"./4-top.png": "a743",
	"./4_1.png": "2747c",
	"./4_2.png": "159c",
	"./4_3.png": "bcf9",
	"./4_4.png": "34b4",
	"./6_icon_Telega.png": "28a9",
	"./6_icon_VS.png": "e2fc",
	"./6_icon_fb.png": "ff26",
	"./6_icon_insta.png": "c7a5",
	"./6_icon_tel.png": "c01a",
	"./arrow.png": "061e",
	"./beginning.png": "5248",
	"./blog/header__arrow.png": "5903",
	"./business/1.png": "5c4d",
	"./business/3.png": "d49d",
	"./business/4_1.png": "478d",
	"./business/4_2.png": "d5c0",
	"./business/4_3.png": "3050",
	"./business/5.png": "f86f",
	"./business/6_1.png": "62e3",
	"./business/6_2.png": "5f1e",
	"./business/6_3.png": "cfb5",
	"./business/6_4.png": "48a9",
	"./business/arrow1.png": "6513",
	"./business/arrow2.png": "0a74",
	"./business/arrow3.png": "0582",
	"./business/mail.png": "0750",
	"./business/watsupp.png": "e5df",
	"./chat.png": "ffb1",
	"./check-img.png": "3fe6",
	"./devices.png": "77fb",
	"./forPsychologists/Main-image.png": "d438",
	"./forPsychologists/arrow-2.png": "ec69",
	"./forPsychologists/arrow.png": "6ea9",
	"./forPsychologists/require-1.png": "276e",
	"./forPsychologists/require-2.png": "b558",
	"./forPsychologists/require-3.png": "feec",
	"./mail.png": "e9ce",
	"./main-picture.png": "b7c8",
	"./problems-1.png": "6ce6",
	"./problems-2.png": "6609",
	"./problems-3.png": "b90a",
	"./problems-4.png": "61ac",
	"./problems-4rus.png": "2b01",
	"./problems-5.png": "8738",
	"./problems-6.png": "3be1",
	"./usability-1.png": "a189",
	"./usability-2.png": "d785",
	"./usability-3.png": "1e23",
	"./watsapp.png": "d443"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e078";